import { createSlice } from "@reduxjs/toolkit";
import { getColumnList } from "../../reduxApi/admin/ColumnsReduxApi";

const columnSlice = createSlice({
    name: 'column',
    initialState: {
        status: 'idel',
        isFiltered: false,
        column: [],
    },
    reducers: {
        setColumnFilteredStatus: (state, action) => {
            state.isFiltered = action.payload;
        },
        deleteColumnAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.column.findIndex((item) => item.ROWID === id);
                if (index !== -1) {
                    state.column.splice(index, 1);
                }
            });
        },
        updateColumnAction: (state, action) => {
            const index = state.column.findIndex((item) => item.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.column.splice(index, 1, action.payload)
            }
        },
        addColumnAction: (state, action) => {
            console.log("action--->", action.payload);

            const temp = action.payload;
            console.log("temp", temp)
            temp.ROWID = action.payload.ROWID;
            console.log("temp.ROWID", temp.ROWID);

            state.column.unshift(temp); //add new data at beginning of array 
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(getColumnList.pending, (state, action) => {
                state.status = 'pending'
            })
            .addCase(getColumnList.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                state.column = action.payload?.data || [];
            })
            .addCase(getColumnList.rejected, (state) => {
                state.status = 'failed';
            });
    }
})
export const { deleteColumnAction, updateColumnAction, addColumnAction, setColumnFilteredStatus } = columnSlice.actions
export default columnSlice.reducer